import * as React from "react";
function SvgFeed(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <circle fill="#fff" cx={8} cy={24} r={3} />
      <g stroke="#fff" fill="none" strokeWidth={4}>
        <path d="M25 27A20 20 0 005 7M17 27A12 12 0 005 15" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFeed);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
